import React from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

const empty = { term_de: "", definition_de: "", term_en: "", definition_en: "", enabled: true };

export default function GlossaryAdmin() {
  const [items, setItems] = React.useState([]);
  const [draft, setDraft] = React.useState({ ...empty });
  const [editId, setEditId] = React.useState(null);

  const load = () => api.adminGloss().then(setItems);
  React.useEffect(() => { load(); }, []);
  const save = async () => {
    if (editId) await api.updateGloss(editId, draft); else await api.createGloss(draft);
    toast.success("Gespeichert"); setDraft({ ...empty }); setEditId(null); load();
  };
  const remove = async (id) => { if (!window.confirm("Löschen?")) return; await api.deleteGloss(id); load(); };

  return (
    <div data-testid="admin-glossary">
      <div className="mb-6"><div className="brut-tag mb-3">CMS / GLOSSAR</div><h1 className="brut-h2">Glossar</h1></div>
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-3">
          {items.map(it => (
            <div key={it.id} className="border-2 border-[var(--ink)] p-3">
              <div className="flex justify-between gap-2">
                <div>
                  <div className="font-mono text-[10px] uppercase opacity-60">{it.letter}</div>
                  <div className="brut-h3">{it.term_de}</div>
                  <p className="brut-body opacity-80 text-sm mt-1">{it.definition_de}</p>
                </div>
                <div className="flex flex-col gap-1">
                  <button onClick={() => { setDraft(it); setEditId(it.id); }} className="font-mono text-xs underline">Edit</button>
                  <button onClick={() => remove(it.id)} className="font-mono text-xs underline text-red-600">Del</button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="col-span-12 md:col-span-5">
          <div className="border-2 border-[var(--ink)] p-4 space-y-3 sticky top-6">
            <div className="font-mono text-xs uppercase tracking-[0.2em]">{editId ? "Begriff bearbeiten" : "Neuer Begriff"}</div>
            <input className="brut-input" placeholder="Begriff (DE)" value={draft.term_de} onChange={e => setDraft({ ...draft, term_de: e.target.value })} />
            <textarea rows={3} className="brut-textarea" placeholder="Definition (DE)" value={draft.definition_de} onChange={e => setDraft({ ...draft, definition_de: e.target.value })} />
            <input className="brut-input" placeholder="Term (EN)" value={draft.term_en} onChange={e => setDraft({ ...draft, term_en: e.target.value })} />
            <textarea rows={2} className="brut-textarea" placeholder="Definition (EN)" value={draft.definition_en} onChange={e => setDraft({ ...draft, definition_en: e.target.value })} />
            <div className="flex gap-2">
              <button onClick={save} className="brut-btn !py-2 !px-3 text-xs"><Save size={12}/> Speichern</button>
              {editId && <button onClick={() => { setDraft({ ...empty }); setEditId(null); }} className="font-mono text-xs underline">Abbrechen</button>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
